import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Small } from 'foundations-components/transitional/components/Small';
import { Button } from 'foundations-components/transitional/components/Button';
import { BaseContentControlWrapper } from './ContentControlWrapper.migrated';
import { replacePlaceholderWithPortalId } from '../utils/RoutingUtils.migrated';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LinkContent = ({
  contentType,
  ctaCopy,
  description,
  name,
  href,
  onFinish = () => {},
  onSkip = () => {},
  hasClicked,
  onRead = () => {}
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    padding: "0",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      blockSize: "100%",
      inlineSize: "100%",
      justifyContent: "space-around",
      paddingBlock: "1400",
      paddingInline: "1000",
      children: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          flexWrap: "wrap",
          justifyContent: "start",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h1",
            marginBlockEnd: "400",
            children: name
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            marginBlockEnd: "800",
            children: description
          }), !hasClicked ? /*#__PURE__*/_jsx(Button, {
            external: true,
            href: replacePlaceholderWithPortalId(PortalIdParser.get(), href),
            marginBlockEnd: "1100",
            onClick: onRead,
            use: "primary",
            children: ctaCopy || /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "learningCenter.linkContent.buttonAltText",
              options: {
                name: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `learningCenter.resources.type.${readUnhandledEnumCase(contentType)}`
                })
              }
            })
          }) : /*#__PURE__*/_jsx(Button, {
            marginBlockEnd: "1100",
            onClick: onFinish,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.common.next"
            })
          }), /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.linkContent.newTabText"
            })
          })]
        })
      })
    })
  }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
    children: /*#__PURE__*/_jsx(Button, {
      onClick: onSkip,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.linkContent.skip"
      })
    })
  })]
});
export default LinkContent;